import { render, staticRenderFns } from "./BlockTransactions.vue?vue&type=template&id=ad459c4c&scoped=true&"
import script from "./BlockTransactions.vue?vue&type=script&lang=ts&"
export * from "./BlockTransactions.vue?vue&type=script&lang=ts&"
import style0 from "./BlockTransactions.vue?vue&type=style&index=0&id=ad459c4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad459c4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VDivider})
